export function CommissionPendingBadge({ long = false }: { long?: boolean }) {
  return (
    <span className="w-fit rounded border border-warning-border bg-warning-bg px-2 py-0.5 text-[10px] font-semibold text-warning-text">
      {long ? "Modification en attente" : "Modif. en attente"}
    </span>
  );
}
